import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import DataTable from '../../components/design/DataTable.jsx';
import { getVideo, listVideos, mintPublicAssetLink } from '../../services/contentAiService';

function statusLabel(s) {
  const v = String(s || '').toLowerCase();
  if (!v) return '';
  return v;
}

export default function VideosPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const resp = await listVideos(100);
      const data = resp?.data || [];
      setRows(Array.isArray(data) ? data : []);
    } catch (e) {
      toast.error(e?.message || 'Falha ao carregar vídeos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const openDetails = async (row) => {
    setLoading(true);
    try {
      const resp = await getVideo(row.id);
      const data = resp?.data || null;
      setDetails(data);
      setOpen(true);
    } catch (e) {
      toast.error(e?.message || 'Falha ao carregar detalhes');
    } finally {
      setLoading(false);
    }
  };

  const createPublicLink = async (assetId) => {
    if (!assetId) return;
    try {
      const resp = await mintPublicAssetLink(assetId, 1440);
      const url = resp?.data?.url || null;
      if (!url) throw new Error('URL não gerada');
      await navigator.clipboard.writeText(url);
      toast.success('Link copiado');
    } catch (e) {
      toast.error(e?.message || 'Falha ao gerar link público');
    }
  };

  return (
    <Box p={2} display="grid" gap={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">Vídeos</Typography>
        <Button variant="outlined" onClick={load} disabled={loading}>Atualizar</Button>
      </Box>

      <DataTable
        rows={rows}
        loading={loading}
        columns={[
          { field: 'id', headerName: 'ID', width: 90 },
          { field: 'title', headerName: 'Título', flex: 1, minWidth: 240 },
          { field: 'status', headerName: 'Status', width: 140, valueGetter: (p) => statusLabel(p?.row?.status) },
          { field: 'createdAt', headerName: 'Criado', width: 180, valueGetter: (p) => (p?.row?.createdAt ? new Date(p.row.createdAt).toLocaleString() : '') },
          {
            field: 'actions',
            headerName: 'Ações',
            width: 140,
            sortable: false,
            renderCell: (params) => (
              <Button size="small" variant="outlined" onClick={() => openDetails(params.row)}>Detalhes</Button>
            )
          }
        ]}
        getRowId={(r) => r.id}
      />

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Detalhes do vídeo</DialogTitle>
        <DialogContent>
          <Box display="grid" gap={1} mt={1}>
            <Typography><strong>ID:</strong> {details?.id}</Typography>
            <Typography><strong>Título:</strong> {details?.title}</Typography>
            <Typography><strong>Status:</strong> {details?.status}</Typography>
            <Typography><strong>Template:</strong> {details?.templateId || '-'}</Typography>
            <Typography><strong>Agendado:</strong> {details?.scheduledPublishAt ? new Date(details.scheduledPublishAt).toLocaleString() : '-'}</Typography>
            <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
              {details?.id ? (
                <Button variant="outlined" onClick={() => navigate(`/video-editor/${details.id}`)}>Editar timeline</Button>
              ) : null}
              {details?.outputVideoAssetId ? (
                <Button variant="contained" onClick={() => createPublicLink(details.outputVideoAssetId)}>Link público do vídeo</Button>
              ) : null}
              {details?.thumbnailAssetId ? (
                <Button variant="outlined" onClick={() => createPublicLink(details.thumbnailAssetId)}>Link público da thumb</Button>
              ) : null}
              {details?.subtitleAssetId ? (
                <Button variant="outlined" onClick={() => createPublicLink(details.subtitleAssetId)}>Link público das legendas</Button>
              ) : null}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
